module.exports = __webpack_public_path__ + "media/images/admin/icons/battery-charging-794481196d05f5489db9884d76dc64a7.svg";